import React from 'react';
import { connect } from 'react-redux';

// Components
// import Anchor from 'Components/common/Anchor';
import SearchInput from 'Components/common/SearchInput';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import F1OrderItem from './F1OrderItem';

// Actions
import { T } from 'Actions/translate';
import { 
    getF1OrderSearchList, 
    updateF1OrderSearchFields, 
    updateF1OrderDetails
} from 'Actions/host';

class F1PackageReceive extends React.Component {
    pager = {
        page: 0,
        length: 10,
        pageTotal: 9999999999999999999999999,
        total: 0
    }
    state = {
        isFocus: false,
        listLoaded: true
    }

    getButtonText = () => (this.state.isFocus && this.props.queryKey) ? 'search' : 'cancel';
    onFocus = () => {
        this.setState({ isFocus: true });
        window.clearTimeout(this.blurTimer);
    }
    onBlur = () => {
        window.clearTimeout(this.blurTimer);
        this.blurTimer = window.setTimeout(() => {
            this.setState({ isFocus: false });
        }, 300);
    }
    handleChange = (title, value) => this.props.updateF1OrderSearchFields({
        [title]: { $set: value }
    });

    search = () => {
        switch(this.getButtonText()) {
            case 'search':
                this.pager.page = 0;
                this.pager.total = 0;
                this.pager.pageTotal = 9999999999999999999999999;
                this.getList();
                break;
            default:
                this.props.history.goBack();
                break;
        }
    }

    chooseItem = item => {
        this.props.updateF1OrderDetails({});
        switch(item.status) {
            case 1:
            case 4:
            case -1:
                this.props.history.push(`/F1OrderReceiveManagement/${ item.id }`);
                break;
            default:
                this.props.history.push(`/F1OrderDetails/${ item.id }`);
        }
    }

    getList = () => {
        if(this.pager.page >= this.pager.pageTotal) return;

        this.setState({ listLoaded: false });

        this.props.getF1OrderSearchList({
            pageNum: this.pager.page + 1,
            pageSize: this.pager.length,
            queryKey: this.props.queryKey
        }).then(res => {
            this.pager.page = res.pageNum;
            this.pager.total = res.total;
            this.pager.pageTotal = res.pageTotal;
        }).then(() => {
            this.setState({ listLoaded: true });
        });
    }

    getSearchHistoryTemplate = () => {
        return null;
        /* return (
            <React.Fragment>
                <p className="F1-order-search-history-title">{T('search_history')}</p>
                <ul className="F1-order-search-history clearfix">
                    <li className="F1-order-search-history-item"><Anchor className="F1-order-search-history-value">0012345</Anchor></li>
                    <li className="F1-order-search-history-item"><Anchor className="F1-order-search-history-value">0012345</Anchor></li>
                    <li className="F1-order-search-history-item"><Anchor className="F1-order-search-history-value">0012345</Anchor></li>
                    <li className="F1-order-search-history-item"><Anchor className="F1-order-search-history-value">0012345</Anchor></li>
                    <li className="F1-order-search-history-item"><Anchor className="F1-order-search-history-value">0012345</Anchor></li>
                </ul>
            </React.Fragment>
        ); */
    }

    getSearchListTemplate = () => {
        const { listLoaded } = this.state;

        return (
            <ScrollWrapper listLoaded={ listLoaded } showAbyss={ this.pager.page >= this.pager.pageTotal } showLoadingMore={ !listLoaded } getMoreData={ this.getList }>
                <ul className="F1-order-search-list">
                    {
                        this.props.F1OrderSearchList.map((item, index) => (
                            <li key={ index } className="F1-order-search-item">
                                <F1OrderItem item={ item } key={ index } chooseItem={ () => this.chooseItem(item) }></F1OrderItem>
                            </li>
                        ))
                    }
                </ul>
            </ScrollWrapper>
        );
    }

    render() {
        // const { isFocus } = this.state;
        const { queryKey } = this.props;

        return (
            <div className="F1-order-search-list-container">
                <div className="header-wrap">
                    <div className="F1-order-search-header container-max-width is-fixed">
                        <SearchInput title="queryKey" value={ queryKey } autoFocus={ true } placeholder={ T('enter_sku_orderNo') } onFocus={ this.onFocus } onBlur={ this.onBlur } onChange={ this.handleChange } search={ this.search } options={{ searchText: T(this.getButtonText()) }}/>
                    </div>
                </div>
                {/* { isFocus ? this.getSearchHistoryTemplate() : this.getSearchListTemplate() } */}
                { this.getSearchListTemplate() }
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { host } = state;

    return {
        F1OrderSearchList: host.F1OrderSearchList,
        queryKey: host.F1OrderSearchfields.queryKey
    };
};

const mapDispatchToProps = {
    getF1OrderSearchList,
    updateF1OrderSearchFields,
    updateF1OrderDetails
};

export default connect(mapStateToProps, mapDispatchToProps)(F1PackageReceive);
